import { Link } from "react-router-dom"
import { NitaBadge } from "@/components/NitaBadge"
const logoSrc = "/images/Jero-One_Logo.png";

export function Footer() {
  return (
    <footer className="bg-[#060C0E] border-t border-[#1B5E35]/20">
      <div className="max-w-7xl mx-auto px-6 md:px-14 pt-16 pb-8">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img loading="lazy" decoding="async"
                src={logoSrc}
                alt="Jero-One Technologies"
                className="w-10 h-10 object-contain"
              />
              <div>
                <div
                  className="font-black text-[#F4F6F0] text-sm"
                  style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
                >
                  JERO-ONE
                </div>
                <div className="text-[10px] text-[#6B7C6E] font-mono">
                  TECHNOLOGIES INC.
                </div>
              </div>
            </div>
            <p className="text-[#6B7C6E] text-sm leading-relaxed mb-4">
              Global IT solutions provider with headquarters in Minnesota, USA,
              and franchise offices in Uganda and Canada.
            </p>
          </div>

          {/* Services */}
          <div>
            <div className="font-bold text-[#F4F6F0] text-sm mb-4">
              Services
            </div>
            <ul className="space-y-2 text-sm text-[#6B7C6E]">
              {[
                ["Network Infrastructure", "/networking-project-management-uganda"],
                ["Cloud Solutions", "/cloud-solutions-uganda"],
                ["Cybersecurity", "/cybersecurity-kampala-uganda"],
                ["Fortinet & SD-WAN", "/fortinet-sd-wan-firewall-uganda"],
                ["Managed IT Services", "/managed-it-services-data-center-kampala"],
                ["Managed IT (USA)", "/managed-it-services-minnesota"],
                ["Software & App Development", "/custom-software-app-development-kampala-uganda"],
                ["ERP Systems", "/erp-enterprise-systems-uganda"],
                ["Hospital, POS & Biometrics", "/hospital-systems-pos-biometric-attendance-uganda"],
                ["Conference Rooms", "/conference-room-smart-boards-uganda"],
                ["CCTV & Security", "/cctv-security-uganda"],
                ["Hardware Supply", "/laptops-computers-uganda"],
              ].map(([s, to]) => (
                <li key={s}>
                  <Link
                    to={to}
                    className="hover:text-[#2A7D4A] transition-colors"
                  >
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <div className="font-bold text-[#F4F6F0] text-sm mb-4">Company</div>
            <ul className="space-y-2 text-sm text-[#6B7C6E]">
              {[
                { label: "About Us", to: "/about" },
                { label: "Our Locations", to: "/locations" },
                { label: "Online Shop", to: "/shop" },
                { label: "IT Training", to: "/training" },
                { label: "Website Solutions", to: "/websites" },
                { label: "Careers", to: "/contact" },
                { label: "Contact", to: "/contact" },
                { label: "Track Your Order", to: "/track" },
              ].map(({ label, to }) => (
                <li key={label}>
                  <Link
                    to={to}
                    className="hover:text-[#2A7D4A] transition-colors"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div className="font-bold text-[#F4F6F0] text-sm mb-4">Contact</div>
            <ul className="space-y-3 text-sm text-[#6B7C6E]">
              <li className="flex gap-2">
                <span>🇺🇸</span>
                <span>Minnesota, USA (HQ)</span>
              </li>
              <li className="flex gap-2">
                <span>🇺🇬</span>
                <span>
                  Downtown Entebbe · P.O. Box 171736, Kampala GPO, Uganda
                  {["+256 766 553 449", "+256 701 511 262", "+256 752 200 865"].map((p) => (
                    <a key={p} href={`tel:${p.replace(/\s/g, "")}`} data-testid={`footer-uganda-phone-${p.slice(-3)}`} className="block hover:text-[#2A7D4A] transition-colors">
                      {p}
                    </a>
                  ))}
                </span>
              </li>
              <li className="flex gap-2">
                <span>🇨🇦</span>
                <span>Canada</span>
              </li>
              <li className="flex gap-2">
                <span>✉️</span>
                <a
                  href="mailto:info@jero-onetechnologies.com"
                  className="hover:text-[#2A7D4A] transition-colors break-all"
                >
                  info@jero-onetechnologies.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1B5E35]/10 pt-6 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#6B7C6E]">
          <div className="flex flex-col items-center gap-3 md:flex-row md:gap-5">
            <span>© 2026 Jero-One Technologies Inc. All rights reserved.</span>
            <NitaBadge compact />
          </div>
          <div className="flex gap-6">
            <a
              href="mailto:info@jero-onetechnologies.com?subject=Privacy%20inquiry"
              className="hover:text-[#2A7D4A]"
            >
              Privacy Policy
            </a>
            <a
              href="mailto:info@jero-onetechnologies.com?subject=Terms%20of%20service%20inquiry"
              className="hover:text-[#2A7D4A]"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
